export function capitalize(value: string | null): string {
    if (!value) return '';

    const processed: Array<string> = [];
    const parts = [...value.matchAll(/\b(\w+)(?=([ -])*\b)/g)];

    parts.forEach(part => {
        const word = part[1];
        const separator = part[2];
        const lowerWord = word.toLowerCase();

        processed.push(`${lowerWord[0]?.toUpperCase()}${lowerWord?.substring(1)}`);

        if (separator) {
            processed.push(separator);
        }
    });

    return processed.join('');
}